// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"e6857454","453":"eb122383"}[chunkId] + ".chunk.js";
};